import {useMutation, useQueryClient} from '@tanstack/react-query';
import {I18n} from '@aws-amplify/core';
import {disableRecord, enableRecord} from '../services/BillingProvidersService';
import {BillingProvider} from '../types';
import {notifyError, notifySuccess} from '../../../components/ServiceNotifications.tsx';
import {billingProvidersQueryKeys} from './billingProvidersQueryKeys';

// The row Enable/Disable action. A mutation rather than a raw service call, so the button
// can show it is pending (§2: no dead click) and the invalidation reaches the detail key
// as well as the list (§8).
export const useBillingProviderStatusToggle = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (record: BillingProvider) =>
            record.status === 'Enabled' ? disableRecord(record.id) : enableRecord(record.id),
        onSuccess: (_result, record) => {
            notifySuccess(record.status === 'Enabled'
                              ? I18n.get('Billing Provider disabled')
                              : I18n.get('Billing Provider enabled'));
        },
        onError: (error) => notifyError(error),
        onSettled: () => queryClient.invalidateQueries({queryKey: billingProvidersQueryKeys.all}),
    });

    return {
        toggleStatus: (record: BillingProvider) => mutation.mutate(record),
        // The id in flight, so only that row's button shows the spinner.
        pendingId: mutation.isPending ? mutation.variables?.id : undefined,
    };
};
